<template>
	<div>
		<b-container fluid class="margin-top-header">
			<b-row>
				<b-col lg="8" offset-lg="2" > 
					<b-table-simple borderless class="bg-grey shadow-sm my-5">
						<b-tr>
							<b-td rowspan="2" class="no-padding text-right d-none d-md-table-cell" style="vertical-align: middle;">
								<font-awesome-icon :icon="['fal', 'check-circle']" size="10x" class="text-macal" />
							</b-td>
							<b-td class="no-padding"><span class="section-header">¡{{customer.name}}, Gracias por preferirnos!  </span></b-td>
						</b-tr>
						<b-tr>
							<b-td class="no-padding">
								<span class="section-subheader">Tu solicitud de traslado será procesada y nos contactaremos contigo.</span>
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-col>
			</b-row>
			<b-row class="pb-5">
				<b-col offset-lg="2" lg="8" class="text-center" >
					<b-button v-if="car_id" size="lg" class="mt-3 pl-5 pr-5" variant="macal" :to="'/auto/'+car_id" >Vuelve al automóvil que estas viendo</b-button>
					<b-button v-else size="lg" class="mt-3 pl-5 pr-5" variant="macal" to="/autos">Ahora sigue viendo autos en Macal</b-button>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
  export default {
    name: 'financing-success',
    components: {},
	props: {
		car_id: {default: null},
        customer:{
            rut: {default: null},
            name: {default: null},
            lastnameFather: {default: null},
            lastnameMother: {default: null},
            phone: {default: null},
            email: {default: null},
            region_id: {default: null},
            commune_id: {default: null},
            name_contact: {default: null},
            phone_contact: {default: null},
            reference: {default: null}
        }
    },
	data (){
		return{
			amount: "",
			due: 60,
			loading: false,
            color: "#E4610C",
			state: null,
		}
	},
	mounted() {

	},
	methods:{
	},
	watch: {
		price: {
			handler: function() {}
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>